import { render } from "./WelcomeInstructions.vue?vue&type=template&id=0457e743"
import script from "./WelcomeInstructions.vue?vue&type=script&lang=js"
export * from "./WelcomeInstructions.vue?vue&type=script&lang=js"

import "./WelcomeInstructions.vue?vue&type=style&index=0&id=0457e743&lang=css"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__